import React, { useCallback } from 'react';

import { DesktopOnly, MobileOnly } from 'shared/components';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { BottomDrawer, ModalContainer } from 'components/core';
import { ModalComponentProps, withModalControlsHook } from 'components/modals/with-modal-controls-hook';

import { StoreRoutingOffer, StoreRoutingOfferData } from './store-routing-offer';

export type StoreRoutingOfferResult = 'accepted' | 'declined';

type StoreRoutingOfferModalProps = ModalComponentProps<StoreRoutingOfferData, StoreRoutingOfferResult>;

function StoreRoutingOfferModal({ containerProps, data, onClose }: StoreRoutingOfferModalProps): JSX.Element {
  const handleAccept = useCallback((): void => onClose('accepted'), [onClose]);
  const handleDecline = useCallback((): void => onClose('declined'), [onClose]);

  return (
    <>
      <DesktopOnly mediaQuery='sm'>
        <ModalWrapper open onClose={handleDecline}>
          <ModalContainer width='502px' p='45px' {...containerProps}>
            <StoreRoutingOffer data={data} onAccept={handleAccept} onDecline={handleDecline} />
          </ModalContainer>
        </ModalWrapper>
      </DesktopOnly>
      <MobileOnly mediaQuery='xs'>
        <BottomDrawer open onClose={handleDecline} hideExitIcon shouldCalculateIframeBottom {...containerProps}>
          <StoreRoutingOffer data={data} onAccept={handleAccept} onDecline={handleDecline} />
        </BottomDrawer>
      </MobileOnly>
    </>
  );
}

const [StoreRoutingOfferController, useStoreRoutingOfferModal] = withModalControlsHook<
  StoreRoutingOfferData,
  StoreRoutingOfferResult
>(StoreRoutingOfferModal);

export { StoreRoutingOfferController, useStoreRoutingOfferModal };
